@if (hasFirstSteps()) {
  <acc-card>
    <acc-card-header class="text-center">
      {{ 'firstSteps.title'|translate }}
    </acc-card-header>
    <acc-card-body>
      <div class="d-flex flex-column gap-2 align-items-center">
        @if (isFirstStepsOrgAddressMissing()) {
          <acc-button [minWidth]="40"
                      (accClick)="gotoOrgSettings()">
            {{ 'firstSteps.enter.org.address'|translate }}
          </acc-button>
        }
        <!-- Add Org-Bank-Address -->
        @if (isFirstStepsOrgBankAddressMissing()) {
          <div class="d-flex gap-2 acc-btn-mw-40">
            <div class="flex-fill">
              <acc-button accClass="w-100" (accClick)="gotoOrgSettings()">
                {{ 'firstSteps.enter.org.bankAddress'|translate }}
              </acc-button>
            </div>
            <acc-button class="action" status="outline-danger" [ngbTooltip]="'firstSteps.ignore'|translate"
                        (accClick)="ignoreFirstStepsOrgBankAddress()">
              <acc-icon name="cancel"/>
            </acc-button>
          </div>
        }
        <!-- Create first Contact -->
        @if (isFirstStepsContactMissing()) {
          <div class="d-flex gap-2 acc-btn-mw-40">
            <div class="flex-fill">
              <acc-button accClass="w-100" [disabled]="isFirstStepsContactDisabled()"
                          (accClick)="gotoContactNew()">
                {{ 'firstSteps.enter.contact'|translate }}
              </acc-button>
            </div>
            <acc-button class="action" status="outline-danger" [ngbTooltip]="'firstSteps.ignore'|translate"
                        [disabled]="isFirstStepsContactDisabled()"
                        (accClick)="ignoreFirstStepsContact()">
              <acc-icon name="cancel"/>
            </acc-button>
          </div>
        }
        <!-- Create first invoice -->
        @if (isFirstStepsInvoiceDraftMissing()) {
          <div class="d-flex gap-2 acc-btn-mw-40">
            <div class="flex-fill">
              <acc-button accClass="w-100" [disabled]="isFirstStepsInvoiceDraftDisabled()"
                          (accClick)="gotoInvoiceNew()">
                {{ 'firstSteps.create.invoice.draft'|translate }}
              </acc-button>
            </div>
            <acc-button class="action" status="outline-danger" [ngbTooltip]="'firstSteps.ignore'|translate"
                        [disabled]="isFirstStepsInvoiceDraftDisabled()"
                        (accClick)="ignoreFirstStepsInvoiceDraft()">
              <acc-icon name="cancel"/>
            </acc-button>
          </div>
        }
        <!-- Register first Org -->
        @if (isFirstStepsUserRegisterOrg()) {
          <acc-button [minWidth]="40"
                      (accClick)="gotoOrgList()">
            <div>{{ 'firstSteps.org.register'|translate }}</div>
            @if (isFirstStepsUserInvited()) {
              <div>{{ 'firstSteps.org.accept.invitation'|translate }}</div>
            }
          </acc-button>
        }
      </div>
    </acc-card-body>
  </acc-card>
}
